<template>
  <section
    :style="data.style ? data.style : isDark ? 'secondary' : ''"
    :class="`${isDark ? 'secondary white--text' : ''}  ${data.class}`"
  >
    <v-container :class="`video py-0 ${isDark ? 'white--text' : ''}`">
      <v-row justify="center" align="center">
        <v-col cols="12" sm="10" md="5" lg="5" xl="5" class="text-center">
          <v-row justify="center">
            <v-col cols="12" sm="12" md="12" lg="11" xl="9">
              <v-card>
                <v-img
                  :aspect-ratio="16 / 9"
                  :contain="data.video.url ? false : true"
                  :src="data.video.thumbnail"
                >
                  <v-row
                    class="pa-2 fill-height"
                    v-if="data.video.url"
                    @click="$eventBus.$emit('play_video', data.video.url)"
                  >
                    <v-fade-transition>
                      <v-overlay :absolute="true" :value="true" :opacity="0.2">
                        <v-btn color="primary">
                          <v-icon small>fa-play</v-icon>
                        </v-btn>
                      </v-overlay>
                    </v-fade-transition>
                  </v-row>
                </v-img>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="11" sm="10" md="7" lg="7" xl="4">
          <h1 class>{{ data.title }}</h1>
          <p v-html="data.description"></p>

          <v-dialog v-model="dialog" width="420" persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="data.button_color"
                v-bind="attrs"
                dark
                v-on="on"
                class="mt-2"
                >{{ data.button_text }}</v-btn
              >
            </template>
            <v-card :loading="loading">
              <v-card-title class="secondary white--text">
                {{ data.button_text }}
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialog = false">
                  <v-icon>fa-times</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="py-6">
                <v-text-field
                  label="Your email"
                  prepend-icon="fa-at"
                  type="email"
                  validate-on-blur
                  :rules="[rules.required, rules.email]"
                  v-model="email"
                ></v-text-field>
                <v-text-field
                  label="Your phone number"
                  prepend-icon="fa-phone"
                  v-mask="`(###) ###-####`"
                  v-model="phone"
                  validate-on-blur
                  :rules="[rules.required, rules.phone]"
                  type="tel"
                ></v-text-field>

                <v-text-field
                  prepend-icon="fa-user"
                  label="Name"
                  v-model="name"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-textarea
                  label="Message"
                  v-model="message"
                  :rows="5"
                ></v-textarea>
              </v-card-text>
              <v-card-actions class="grey lighten-3">
                <v-spacer></v-spacer>
                <v-btn
                  :color="data.button_color"
                  dark
                  @click="submit"
                  :loading="loading"
                  >Submit</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "PageVideo",
  props: ["value"],
  data() {
    return {
      dialog: false,
      loading: false,
      name: "",
      email: "",
      phone: "",
      message: "",
    };
  },
  computed: {
    rules() {
      return this.$helpers.rules;
    },
    data() {
      return this.value;
    },
    isDark() {
      return this.value.dark ? true : false;
    },
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        await this.$api.post(`/contact`, {
          name: this.name,
          phone: this.phone,
          message: this.message,
          email: this.email,
          email_list_id: this.data.email_list_id,
        });
        this.email = "";
        this.name = "";
        this.phone = "";
        this.message = "";
        this.dialog = false;
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.video-card {
  padding: 50px;

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    padding: 20px;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    padding: 20px;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    padding: 10px;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    padding: 50px;
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    padding: 50px;
  }
}
.video a {
  text-decoration: none;
}
</style>